import { NavLink } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { api } from '../lib/api';

// ================================================================
// Sidebar
// ================================================================

export function Sidebar() {
  const [summary, setSummary] = useState<{ overdue?: any[]; critical?: any[] }>({});

  useEffect(() => {
    api.obligations.summary().then(setSummary).catch(() => {});
  }, []);

  const overdueCount = summary.overdue?.length ?? 0;
  const criticalCount = summary.critical?.length ?? 0;
  const alertsCount = overdueCount + criticalCount;

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <div className="sidebar-brand-mark">
          ILU <em>LLC</em> OS
        </div>
        <span className="sidebar-brand-sub">Wyoming · Foreign-Owned</span>
      </div>

      <div className="nav-group">
        <span className="nav-group-label">Principal</span>
        <NavLink to="/" end className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')}>
          Dashboard
        </NavLink>
        <NavLink to="/timeline" className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')}>
          Timeline
          {alertsCount > 0 && (
            <span className={`nav-item-badge ${overdueCount === 0 ? 'warning' : ''}`}>{alertsCount}</span>
          )}
        </NavLink>
        <NavLink to="/entity" className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')}>
          Entidad
        </NavLink>
      </div>

      <div className="nav-group">
        <span className="nav-group-label">Compliance</span>
        <NavLink to="/compliance/federal" className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')}>
          Federal · IRS
        </NavLink>
        <NavLink to="/compliance/wyoming" className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')}>
          Wyoming
        </NavLink>
        <NavLink to="/transactions" className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')}>
          Transacciones
        </NavLink>
        <NavLink to="/notices" className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')}>
          Notices (IRS)
        </NavLink>
      </div>

      <div className="nav-group">
        <span className="nav-group-label">Operación</span>
        <NavLink to="/documents" className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')}>
          Documentos
        </NavLink>
        <NavLink to="/contracts" className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')}>
          Contratos
        </NavLink>
      </div>

      <div className="nav-group">
        <span className="nav-group-label">Aprendizaje</span>
        <NavLink to="/learn" className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')}>
          Biblioteca
        </NavLink>
      </div>

      <div className="sidebar-footer">
        v0.1.0<br />
        ILU Tech ® 2026
      </div>
    </aside>
  );
}

// ================================================================
// Loading
// ================================================================

export function Loading({ label = 'Cargando' }: { label?: string }) {
  return (
    <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--text-muted)' }}>
      <span className="mono" style={{ fontSize: '0.75rem', letterSpacing: '0.2em', textTransform: 'uppercase' }}>
        {label}…
      </span>
    </div>
  );
}

// ================================================================
// Empty state
// ================================================================

export function Empty({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: React.ReactNode;
}) {
  return (
    <div className="card" style={{ textAlign: 'center', padding: '4rem 2rem' }}>
      <h3 style={{ fontFamily: 'var(--font-display)', fontStyle: 'italic', fontWeight: 400, marginBottom: '0.5rem', color: 'var(--text-dim)' }}>
        {title}
      </h3>
      {description && (
        <p style={{ color: 'var(--text-muted)', marginBottom: action ? '1.5rem' : 0, maxWidth: '44ch', margin: '0 auto 1.5rem' }}>
          {description}
        </p>
      )}
      {action}
    </div>
  );
}

// ================================================================
// Status pill
// ================================================================

export function StatusPill({ urgency, label }: { urgency: string; label: string }) {
  return (
    <span
      className="mono"
      style={{
        fontSize: '0.7rem',
        textTransform: 'uppercase',
        letterSpacing: '0.15em',
        padding: '4px 10px',
        borderRadius: '999px',
        border: '1px solid currentColor',
        color:
          urgency === 'overdue'
            ? 'var(--danger-bright)'
            : urgency === 'critical'
            ? 'var(--danger)'
            : urgency === 'warning'
            ? 'var(--accent)'
            : urgency === 'completed'
            ? 'var(--success)'
            : 'var(--text-muted)',
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </span>
  );
}
